'use strict';

// Import Libraries
import React from 'react';
// Import JS Modules
// Import JSX Modules
import FullScreenSpinnerBase from '../../common/notices/full-screen-spinner-base.jsx'
import Spinner               from '../../../_utils/spinner';

// -----------------------------------------------------------

class FullScreenSpinner extends FullScreenSpinnerBase {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.state.visible) {
      return null;
    }

    return (
      <div className="mobile-full-screen light-zone full-screen-spinner">
        <Spinner />
      </div>
    );
  }
}

// -----------------------------------------------------------

export default FullScreenSpinner;
